import { JSX } from "solid-js";
import { useBrandl2WebstoreTelescopeContext } from "../context/brandl2_webstore_telescope_context";
import { Accordion } from "~/components/webstore_telescope/accordian_faq_section";

/**
 * FAQs section with custom accordion implementation
 * Matches Figma design: 606-31643
 */

export function FaqsSection(): JSX.Element {
  const { getFaqs } = useBrandl2WebstoreTelescopeContext();
  const faqs = getFaqs();
  return <Accordion faqs={faqs} title="FAQs" />;
}
